<ng-container *ngIf="showModalBody">
    <res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
        [primaryButtonLabel]="entityData.okLabel" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
        [isPrimaryBtnEnabled]="!isBusy && entityData" [secondaryButtonLabel]="secondaryButtonLabel" [(isBusy)]="isBusy"
        [(isBusyMessage)]="entityData.isBusyMessage" [modalHelpIndex]="modalHelpIndex">

        <div *ngIf="entityData.contentTemplate === null" class="delete-panel">
            <i *ngIf="((modalData.viewType === 'TAG' || viewType === 'TAG') && modalData.documentCount > 0) || entityData.useWarningStyle"
                class="fa fa-exclamation-triangle warning"></i>
            <div [attr.data-automation-id]="modalAutomationId + '-delete-message'" class="message"
                [innerHTML]="entityData.message"></div>
        </div>

        <ng-container *ngTemplateOutlet="entityData.contentTemplate"></ng-container>
    </res-base-modal>
</ng-container>

<ng-template #customTemplate>
    <div class="custom-template" [attr.data-automation-id]="modalAutomationId + '-delete-message'">
        <!-- Approve Project Deletion -->
        <ng-container *ngIf="modalData?.projectAction === 'Approve Project Deletion'; else requestProjectDeletion">
            <div [attr.data-automation-id]="modalAutomationId + '-deletion-message'">
                Are you sure you want to proceed with the deletion of Project <span>{{modalData?.name}}</span>?<br>
                <span>Caution: This action cannot be undone.</span>
            </div>
            <ng-container *ngIf="sharedCorpora.length > 0">
                <ng-container *ngTemplateOutlet="sharedCorporaBlock"></ng-container>
            </ng-container>
        </ng-container>

        <!-- Request Project Deletion -->
        <ng-template #requestProjectDeletion>
            <div [attr.data-automation-id]="modalAutomationId + '-deletion-message'">
                Once you make the project deletion request, a <span *ngIf="sharedCorpora.length === 0"><br></span>
                System Administrator must approve it.
            </div>
            <ng-container *ngIf="sharedCorpora.length > 0">
                <ng-container *ngTemplateOutlet="sharedCorporaBlock"></ng-container>
            </ng-container>
        </ng-template>
    </div>
</ng-template>

<ng-template #sharedCorporaBlock>
    <br>
    <div [attr.data-automation-id]="modalAutomationId + '-list-message'">
        The following Shared Data Sets are no longer associated with any other project and will also be
        deleted:
    </div>
    <ul>
        <li *ngFor="let item of sharedCorpora; let last = last">
            <ng-container
                *ngTemplateOutlet="item.attributes[0]?.name === 'shortMessageFormat' ? sharedSMFIcon : sharedRegularIcon">
            </ng-container>
            <span [attr.data-automation-id]="modalAutomationId + '-icon-message'">{{item.name}}
                ({{item.documentCount}}) <span *ngIf="!last">,</span></span>
        </li>
    </ul>
</ng-template>

<ng-template #sharedRegularIcon>
    <div class="fa-stack gtn-icon" [attr.data-automation-id]="modalAutomationId + '-icon'">
        <i class="fa fa-stack-1x gtn-icon-sharedDataSet fa-cube color-purple-01"></i>
        <i class="fa fa-stack-1x gtn-second-icon-sharedDataSet fa-circle-thin color-purple-01"></i>
    </div>
</ng-template>

<ng-template #sharedSMFIcon>
    <div class="fa-stack gtn-icon" [attr.data-automation-id]="modalAutomationId + '-icon'">
        <i class="fa fa-stack-1x gtn-icon-sharedDataSet fa-comments-o color-purple-01"></i>
        <i class="fa fa-stack-1x gtn-second-icon-sharedDataSet fa-circle-thin color-purple-01"></i>
    </div>
</ng-template>